if (!customElements.get('media-with-text-video')) {
  class MediaWithTextVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-play-button]');
      this.audioToggle = this.querySelector('[data-audio-toggle]');
      this.clickToPlay = this.dataset.clickToPlay === 'true';
      this.initialMuted = this.dataset.initialMuted === 'true';

      if (!this.video) return;

      this.classList.toggle('is-playing', !this.video.paused);

      this.video.addEventListener('play', () => this.classList.add('is-playing'));
      this.video.addEventListener('pause', () => this.classList.remove('is-playing'));

      if (this.clickToPlay) {
        this.classList.toggle('is-muted', this.video.muted);
      } else {
        this.playDesired();
      }

      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.togglePlayback());
      }

      if (this.audioToggle) {
        this.audioToggle.addEventListener('click', () => this.toggleAudio());
      }
    }

    playDesired() {
      // Setting .muted async (e.g. after the browser already evaluated the
      // element for autoplay) can make an in-flight autoplay get blocked, so
      // drive playback from here instead of trusting the HTML autoplay
      // attribute's timing. Fall back to muted if unmuted playback is denied.
      this.video.muted = this.initialMuted;
      this.classList.toggle('is-muted', this.video.muted);
      const playPromise = this.video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {
          this.video.muted = true;
          this.classList.add('is-muted');
          this.video.play().catch(() => {});
        });
      }
    }

    togglePlayback() {
      if (this.video.paused) {
        this.video.muted = this.initialMuted;
        this.video.play();
        this.playButton.setAttribute('aria-label', 'Pause video');
      } else {
        this.video.pause();
        this.playButton.setAttribute('aria-label', 'Play video');
      }
      this.classList.toggle('is-muted', this.video.muted);
    }

    toggleAudio() {
      this.video.muted = !this.video.muted;
      this.classList.toggle('is-muted', this.video.muted);
    }
  }

  customElements.define('media-with-text-video', MediaWithTextVideo);
}
